module.exports = __webpack_public_path__ + "img/body-1-lg.378097b2.png";